import { GetTagDocument, ListTagsDocument } from './generated/graphql'
import { createQueryHook, modifyQueryHook } from './utils'

export const useGetTag = modifyQueryHook(createQueryHook(GetTagDocument), {
  transform: (name: string) => ({ name }),
  reduce: r => r?.tag,
})

export const useListTags = modifyQueryHook(createQueryHook(ListTagsDocument), {
  reduce: r => r?.tags,
})
